export class TintFilter extends PIXI.Filter<any> {
    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform sampler2D uSampler;
        uniform vec4 uTint;

        void main() {
            gl_FragColor = texture2D(uSampler, vTextureCoord) * uTint;
        }
    `;

    constructor(pTint: number[]) {
        super(undefined, TintFilter.FRAG);
        pTint.push(1); // Always use alpha of 1 for tint
        this.uniforms.uTint = pTint;
    }
}
